export const siteInfo = {
  brand: '最快吃瓜',
  slogan: '快讯合集 · 速览版',
  desc: '一分钟瓜快速回顾，精简爆料直击重点，高效汇总当日要闻。',
  email: 'hello@zuikuai-chigua.example',
};

export const navLinks = [
  { id: 'today', label: '今日速览' },
  { id: 'browse', label: '分类速览' },
  { id: 'ranking', label: '热门排行' },
  { id: 'column', label: '课代表专栏' },
  { id: 'faq', label: '常见问题' },
  { id: 'about', label: '关于我们' },
];

export const categoryTabs = [
  { id: 'all', label: '全部', icon: 'ri-fire-line' },
  { id: 'entertain', label: '综艺' },
  { id: 'movie', label: '影视' },
  { id: 'star', label: '明星' },
  { id: 'music', label: '音乐' },
  { id: 'life', label: '生活方式' },
  { id: 'sports', label: '体娱' },
];

export const todayTimeline = [
  {
    time: '09:20',
    tag: '综艺',
    title: '某热播观察类综艺收官夜收视破新高，话题词刷屏一整天',
    summary: '最后一期全员到齐，名场面连上三条热搜，晚间收视创本季纪录。',
  },
  {
    time: '11:05',
    tag: '明星',
    title: '歌手新单曲空降音乐平台榜单前十，评论区秒变大型认亲现场',
    summary: '上线两小时评论破万，粉丝自发展开"考古"，路人也在排队听歌。',
  },
  {
    time: '13:40',
    tag: '影视',
    title: '都市剧官宣定档下月，预告片里埋的细节被网友逐帧扒出',
    summary: '预告仅 90 秒，却被观众找出三处"隐藏彩蛋"，话题讨论度直线上升。',
  },
  {
    time: '16:15',
    tag: '体娱',
    title: '赛季关键战上演读秒绝杀，解说连喊三声"进了"冲上热搜',
    summary: '最后一分钟剧情跌宕，相关话题浏览量当晚突破千万量级。',
  },
  {
    time: '19:30',
    tag: '生活方式',
    title: '"周末充电"话题刷屏，网友晒出各自的治愈系休闲清单',
    summary: '从露营、烘焙到夜读，五花八门的松弛感攻略成了今日新宠。',
  },
  {
    time: '22:00',
    tag: '音乐',
    title: '音乐节官宣加场，早鸟票开售即罄，二手票价翻了三倍',
    summary: '阵容公布当晚官方加场应援，手速党与蹲守党再次展开年度比拼。',
  },
];

export const feedItems = [
  {
    id: 'f1',
    category: 'entertain',
    tag: '综艺',
    title: '音综"神仙翻唱"再度封神，选手高音切原唱片段全网炸开',
    summary: '本季最佳现场新鲜出炉，导师当场起立，幕后花絮也被顺势挖出。',
    image:
      'https://readdy.ai/api/search-image?query=Modern%20music%20studio%20stage%20with%20vintage%20microphone%2C%20soft%20warm%20amber%20stage%20lights%20and%20spotlights%2C%20editorial%20magazine%20photography%2C%20cinematic%20and%20energetic%20atmosphere%2C%20clean%20composition&width=900&height=640&seq=buzz-ent-01&orientation=landscape',
    readTime: '2分钟',
    likes: '3.2万',
  },
  {
    id: 'f2',
    category: 'movie',
    tag: '影视',
    title: '悬疑新片预告信息量爆炸，导演埋了三年的伏笔终于被对上了',
    summary: '忠实观众连夜复盘前作，才发现片名到配色处处都是提示，含金量拉满。',
    image:
      'https://readdy.ai/api/search-image?query=Dramatic%20cinematic%20film%20set%20with%20film%20clapperboard%2C%20old%20projector%20and%20warm%20dim%20neon%20light%2C%20moody%20editorial%20photography%2C%20mysterious%20and%20intriguing%20atmosphere&width=900&height=640&seq=buzz-movie-01&orientation=landscape',
    readTime: '2分钟',
    likes: '2.8万',
  },
  {
    id: 'f3',
    category: 'star',
    tag: '明星',
    title: '时隔两年再合体，双人营业视频细节被扒，粉丝直呼"圆满"',
    summary: '两人同框的 40 秒互动，被做成表情包连夜传播，路人也看得很开心。',
    image:
      'https://readdy.ai/api/search-image?query=Glowing%20celebrity%20spotlight%20moment%20with%20warm%20golden%20confetti%20and%20soft%20stage%20bokeh%2C%20modern%20editorial%20entertainment%20photography%2C%20bright%20and%20celebratory%20atmosphere&width=900&height=640&seq=buzz-star-01&orientation=landscape',
    readTime: '1分钟',
    likes: '5.1万',
  },
  {
    id: 'f4',
    category: 'music',
    tag: '音乐',
    title: '年度金曲盘点出炉，三首"年度神曲"你今晚都在单曲循环哪首？',
    summary: '从洗脑副歌到高能现场，这份榜单成了不少人的通勤背景音库。',
    image:
      'https://readdy.ai/api/search-image?query=Vintage%20turntable%20and%20vinyl%20records%20on%20warm%20desk%2C%20headphones%20resting%20on%20top%2C%20soft%20cream%20background%2C%20cozy%20editorial%20product%20photography%2C%20music%20themed&width=900&height=640&seq=buzz-music-01&orientation=landscape',
    readTime: '2分钟',
    likes: '4.0万',
  },
  {
    id: 'f5',
    category: 'life',
    tag: '生活方式',
    title: '当代年轻人的"轻旅行"新风向：不赶景点，只为一座城干饭',
    summary: '为了本地特色美食专程打卡，一周一城的高铁特种兵又回来了。',
    image:
      'https://readdy.ai/api/search-image?query=Street%20food%20market%20in%20a%20warm%20old%20town%20at%20golden%20hour%2C%20steaming%20stalls%20and%20vibrant%20food%2C%20travel%20vlog%20style%2C%20lively%20but%20soft%20editorial%20photography&width=900&height=640&seq=buzz-life-01&orientation=landscape',
    readTime: '2分钟',
    likes: '2.3万',
  },
  {
    id: 'f6',
    category: 'sports',
    tag: '体娱',
    title: '解说金句刷屏全网的背后，是这记决定胜负的压哨三分',
    summary: '从领先到被反超再到绝杀，短短两分钟把情绪拉到极致。',
    image:
      'https://readdy.ai/api/search-image?query=Indoor%20basketball%20court%20with%20intense%20game%20moment%2C%20floodlight%20glare%20and%20scoreboard%20blur%2C%20dynamic%20sports%20editorial%20photography%2C%20high%20energy%20atmosphere&width=900&height=640&seq=buzz-sports-01&orientation=landscape',
    readTime: '2分钟',
    likes: '3.6万',
  },
  {
    id: 'f7',
    category: 'entertain',
    tag: '综艺',
    title: '慢综艺的"神仙友谊"太好磕，集体团建名场面一次看个够',
    summary: '一起做饭、一起淋雨、一起躺平，成年人的快乐也可以很简单。',
    image:
      'https://readdy.ai/api/search-image?query=Cozy%20friends%20camping%20barbecue%20by%20bonfire%20at%20dusk%2C%20string%20lights%20and%20laughing%20silhouettes%2C%20heartwarming%20reality%20show%20style%2C%20warm%20soft%20editorial%20photography&width=900&height=640&seq=buzz-ent-02&orientation=landscape',
    readTime: '1分钟',
    likes: '1.9万',
  },
  {
    id: 'f8',
    category: 'star',
    tag: '明星',
    title: '时尚大片"换头级"造型释出，网友：这组不收藏真的亏',
    summary: '从妆造到置景全程在线，多个造型被时尚博主连夜出解析。',
    image:
      'https://readdy.ai/api/search-image?query=High%20fashion%20editorial%20portrait%20with%20dramatic%20lighting%2C%20elegant%20red%20draped%20fabric%20and%20cream%20backdrop%2C%20magazine%20cover%20style%2C%20sophisticated%20and%20refined%20photography&width=900&height=640&seq=buzz-star-02&orientation=landscape',
    readTime: '1分钟',
    likes: '6.4万',
  },
];

export const rankingList = [
  { rank: 1, title: '观察类综艺收官名场面盘点', category: '综艺', heat: '98.6万', trend: 'up' },
  { rank: 2, title: '歌手压轴舞台高音封神现场', category: '音乐', heat: '94.2万', trend: 'up' },
  { rank: 3, title: '悬疑电影彩蛋逐帧解析贴', category: '影视', heat: '88.7万', trend: 'up' },
  { rank: 4, title: '双人营业 40 秒互动表情包', category: '明星', heat: '81.3万', trend: 'up' },
  { rank: 5, title: '绝杀瞬间完整回放与复盘', category: '体娱', heat: '76.9万', trend: 'down' },
  { rank: 6, title: '年度金曲榜单一键收藏清单', category: '音乐', heat: '70.4万', trend: 'up' },
  { rank: 7, title: '年轻人周末充电生活方式图鉴', category: '生活方式', heat: '64.1万', trend: 'down' },
];

export const columnItems = [
  {
    id: 'c1',
    image:
      'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20film%20storyboard%20with%20camera%20and%20scripts%20on%20warm%20table%2C%20director%20chair%20in%20blur%20background%2C%20editorial%20documentary%20photography%2C%20cinematic%20warm%20tones&width=1200&height=800&seq=col-movie-01&orientation=landscape',
    category: '影视深挖',
    title: '把一部热剧"吃"透：那些导演藏在镜头里的细节',
    summary: '从片名配色到转场设计，带你三分钟看懂幕后团队埋下的全部心思，从此追剧不再只看个热闹。',
    author: '课代表·小瓜',
    date: '09-08',
    readTime: '3分钟',
    tags: ['影视', '幕后', '解析'],
  },
  {
    id: 'c2',
    image:
      'https://readdy.ai/api/search-image?query=Concert%20crowd%20with%20raised%20hands%20and%20phone%20lights%2C%20vivid%20stage%20beams%20at%20night%2C%20dynamic%20music%20festival%20editorial%20photography%2C%20energetic%20and%20immersive%20atmosphere&width=1200&height=800&seq=col-music-01&orientation=landscape',
    category: '现场直击',
    title: '音乐节前排的快乐，与现场同频共振的真实感受',
    summary: '提前一小时占位、被挤到前排、跟着全场大合唱——这份沉浸式观演指南给你一次到位的仪式感。',
    author: '课代表·阿瓜',
    date: '09-07',
    readTime: '3分钟',
    tags: ['现场', '音乐节', '攻略'],
  },
  {
    id: 'c3',
    image:
      'https://readdy.ai/api/search-image?query=Cozy%20weekend%20morning%20with%20coffee%20book%20and%20soft%20blanket%20by%20window%2C%20natural%20sunlight%2C%20relaxing%20slow%20living%20editorial%20photography%2C%20warm%20calm%20tone&width=1200&height=800&seq=col-life-01&orientation=landscape',
    category: '生活方式',
    title: '告别无效休息：一套真正能"充上电"的周末松弛指南',
    summary: '放下手机、专注当下，用轻量家务与高浓度爱好，把周末还给自己，能量值直接拉满。',
    author: '课代表·安可',
    date: '09-06',
    readTime: '4分钟',
    tags: ['生活', '松弛', '自我管理'],
  },
];

export const faqList = [
  {
    q: '「最快吃瓜」每天什么时候更新速览？',
    a: '我们在每日三个高峰时段集中汇总——午间 12 点前、晚间 18 点前后与夜间 22 点后，把当日刷屏的吃瓜要闻压缩成"一分钟速览"，方便你在午休、通勤和睡前快速补课。',
  },
  {
    q: '页面里的内容都是真实发生的吗？',
    a: '本站定位为"速览合集"演示内容站点，当前版块内容为示例数据，用于呈现信息结构与阅读体验。真实发布前我们会以可溯源的一手报道与官方声明为准，并标注来源时间。',
  },
  {
    q: '精简爆料会断章取义、带节奏吗？',
    a: '不会。我们坚持"先看全、再精简"的原则：每条速览都基于完整信息提炼要点，保留时间线与关键前提，避免只截取最容易引发误读的一两句话。',
  },
  {
    q: '我想订阅每天的快讯合集，怎么操作？',
    a: '下拉至页面底部，在"订阅每日速览"区域输入你的常用邮箱并点击订阅即可。我们会把当日精华合集准时投递到你的收件箱，随时可一键退订。',
  },
  {
    q: '内容可以转载或引用吗？',
    a: '转载时请保留原文链接与出处。站内的原创课代表专栏谢绝洗稿，合作或授权需求可通过页面底部的联系方式与我们沟通。',
  },
];

export const aboutStats = [
  { value: '1200+', label: '累计速览合集' },
  { value: '8', label: '分钟·平均阅读时长' },
  { value: '99%', label: '内容可溯源率' },
  { value: '3', label: '每日更新档位' },
];

export const brandPoints = [
  {
    icon: 'ri-time-line',
    title: '一分钟快回顾',
    desc: '每条速览只留干货，剔除注水，让你在最短时间里抓住核心重点。',
  },
  {
    icon: 'ri-scissors-2-line',
    title: '精简爆料直击要点',
    desc: '先看全、再提炼，保留前提与时间线，不靠断章取义博眼球。',
  },
  {
    icon: 'ri-stack-line',
    title: '高效汇总当日要闻',
    desc: '分类归整、热度排序，热门事件与冷门好料一网打尽，一眼看懂今日脉络。',
  },
  {
    icon: 'ri-goblet-line',
    title: '通勤路上的好搭子',
    desc: '课代表帮你提前做功课，地铁上几分钟就能补完全部重点内容。',
  },
];

export const testimonialList = [
  {
    name: '早八通勤族',
    role: '每日订阅用户',
    text: '早上挤地铁的时间刚好刷完今日合集，中午午休再回来看深度专栏，一天吃瓜完全不掉队。',
  },
  {
    name: '碎片党',
    role: '学生党',
    text: '最怕别人聊梗我接不上，现在课代表专栏把来龙去脉讲清楚，终于能自然接话了。',
  },
  {
    name: '周末宅',
    role: '平台老粉',
    text: '分类很清晰，热度和时间都标得很明白，逛起来不累，信息密度刚刚好。',
  },
];